import { render, staticRenderFns } from "./basic-legend-item.vue?vue&type=template&id=cf1e18d4"
import script from "./basic-legend-item.vue?vue&type=script&lang=js"
export * from "./basic-legend-item.vue?vue&type=script&lang=js"
import style0 from "./basic-legend-item.vue?vue&type=style&index=0&id=cf1e18d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports